import axios from "axios";
import {ElMessage} from "element-plus";

const http = axios.create({
    timeout: 180000,
    baseURL: "/api"
})
http.cancel = null;
http.interceptors.request.use(
    (config) => {
        if(!config.cancel){
            return config
        }else  {
            addPendingRequest(config)
            return config
        }
    },
    (error) => {
        Promise.reject(error)
    }
)
http.interceptors.response.use(
    (res) => {
        if (res.status === 200) {
            return res.data
        }
    },
    (error) => {
        ElMessage.closeAll()
        let reg = new RegExp(/timeout/);
        if (axios.isCancel(error)) {
            // 请求取消
            console.warn(error)
            console.table([error.message.split('---')[0]], 'cancel')
        } else if (error.message === 'Network Error') {
            ElMessage.error({
                message: "网络错误"
            })
        } else if (reg.test(error.message)) {
            ElMessage.error({
                message: "请求超时"
            })
        }
        if (error.response !== undefined) {
            let responseData = error.response;
            if (responseData.status === 404) {
                ElMessage.error({
                    message: "接口不存在，404"
                })
            } else if (responseData.status === 401) {
                if(responseData.data.msg){
                    ElMessage.error({
                        message: responseData.data.msg
                    })
                }else{
                    ElMessage.error({
                        message: responseData.data.message
                    })
                }
            } else if (responseData.status === 400) {
                ElMessage.error({
                    message: responseData.data.msg
                })
            }
        }
        return Promise.reject(error)
    }
)
let pendingRequestList = [];
export const cancelPendingRequest=()=>{
    console.log(pendingRequestList)
    pendingRequestList.forEach((item)=> {
        item.cancel();
    })
    pendingRequestList = [];
}
function addPendingRequest(config) {
    config.cancelToken = new axios.CancelToken((cancel)=> {
        pendingRequestList.push({
            cancel
        })
    })
}
export default http
